module.exports = __webpack_public_path__ + "img/erweima.0bc5b7be.png";